import { DrawerItem } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { Logout } from "@mui/icons-material";
import useAuth from "@/components/Authentication/hooks/useAuth";

export const BottomDrawerItems = () => {
	const { t } = useTranslation();
	const { logout } = useAuth();

	return <>
		<DrawerItem 
			label={t("common:text.logout_title")}
			icon={<Logout />} 
			onClick={() => logout()}
		/>
	</>
}
